import React from 'react';
import { Switch } from 'antd';

export const placeholder = [
	{
		key: '10',
		check1: 'Access to backend user management',
		check2: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check3: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check4: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check5: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		)
	},
	{
		key: '20',
		check1: 'Access to list of users',
		check2: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check3: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check4: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check5: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		)
	},
	{
		key: '30',
		check1: 'Access to the dashboard',
		check2: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check3: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check4: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check5: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		)
	},
	{
		key: '40',
		check1: 'Access to the transaction search',
		check2: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check3: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check4: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		),
		check5: (
			<div>
				<Switch size="small" loading={true} checkedChildren="on" unCheckedChildren="off" disabled={true} />
			</div>
		)
	}
];
